

<template>
    <transition name="modal">
        <div class="modal-mask" v-if="isModalVisible && isNeedQuestion">
            <div class="modal-wrapper">
                <div class="modal-container --survey">
                    <div class="modal-header">
                        <h3>Опрос</h3>
                        <button type="button" class="btn-close-modal" @click="close()">×</button>
                    </div>
                    <div class="modal-body">
                        <div  class="card__reviews container">
                            <div  class="review">
                                <h3 v-if="isEmployee">Поставьте оценку работы в нашей компании</h3>
                                <h3 v-else>Поставьте оценку работы с нашей компанией</h3>
                                <div class="review__header">
                                    <div class="review__left">
                                        <div class="review__rating rating" @mouseleave="clearView">
                                            <div class="rating__star" :class="{'active':viewRating >= 1 || setRating >= 1}" @mouseover="viewRate(1)" @click="setRate(1)">
                                                1
                                            </div>
                                            <div class="rating__star" :class="{'active':viewRating >= 2  || setRating >= 2}" @mouseover="viewRate(2)" @click="setRate(2)">
                                                <span>2</span>
                                            </div>
                                            <div class="rating__star" :class="{'active':viewRating >= 3  || setRating >= 3}" @mouseover="viewRate(3)" @click="setRate(3)">
                                                <span>3</span>
                                            </div>
                                            <div class="rating__star" :class="{'active':viewRating >= 4  || setRating >= 4}" @mouseover="viewRate(4)" @click="setRate(4)">
                                                <span>4</span>
                                            </div>
                                            <div class="rating__star" :class="{'active':viewRating >= 5  || setRating >= 5}" @mouseover="viewRate(5)" @click="setRate(5)">
                                                <span>5</span>
                                            </div>
                                            <div class="rating__star" :class="{'active':viewRating >= 6  || setRating >= 6}" @mouseover="viewRate(6)" @click="setRate(6)">
                                                <span>6</span>
                                            </div>
                                            <div class="rating__star" :class="{'active':viewRating >= 7  || setRating >= 7}" @mouseover="viewRate(7)" @click="setRate(7)">
                                                <span>7</span>
                                            </div>
                                            <div class="rating__star" :class="{'active':viewRating >= 8  || setRating >= 8}" @mouseover="viewRate(8)" @click="setRate(8)">
                                                <span>8</span>
                                            </div>
                                            <div class="rating__star" :class="{'active':viewRating >= 9  || setRating >= 9}" @mouseover="viewRate(9)" @click="setRate(9)">
                                                <span>9</span>
                                            </div>
                                            <div class="rating__star" :class="{'active':viewRating == 10  || setRating == 10}" @mouseover="viewRate(10)" @click="setRate(10)">
                                                <span>10</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="setRating < 10 && setRating != 0" class="review__body" style="display: flex;justify-content: center;">
                                    <textarea placeholder="Что нужно сделать чтобы ваша оценка была 10?" v-model="comment" name="comment"></textarea>
                                </div>
                                <a href="javascript:void(0);" @click="send" class="form-data__button button button_theme_primary_blue button_size_md">Отправить</a>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <a class="modal-default-button" @click="close()">
                            Закрыть
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>



<script>
    import axios from "axios";


    export default {
        name: "Survey",
        data: function () {
            return {
                user: this.$ls.get('user') ?? null,
                comment:'',
                viewRating:0,
                setRating:0,
                isModalVisible:true,
                isEmployee:true,
                isAnonymous:false,
                isNeedQuestion:false,
            }
        },
        mounted() {
            if(this.user && this.user.id > 0){
                this.isNeedQuestion = true;
                const splitMail = this.user.login.split("@");
                if(splitMail[1] == "igr.ru"){
                    this.isEmployee = true;
                }
            }else{
                this.isNeedQuestion = true;
                this.isEmployee = true;
                this.isAnonymous = true;
            }
        },
        filters: {

        },
        methods: {
            close() {
                this.isModalVisible = false;
                //TODO:отправим команду скрыть на месяц
                this.hideQuestion();
            },
            clearView: function(rate){
                this.viewRating = 0;
            },
            viewRate: function(rate){
                //this.setRating = 0;
                this.viewRating = rate;
            },
            setRate: function(rate){
                this.setRating = rate;
            },
            hideQuestion: function () {
                let id = 1;

                const headers = {
                    //'Content-Type': 'application/json',
                    'X-Bitrix-Csrf-Token':BX.message('bitrix_sessid'),
                };

                axios.post(
                    '/bitrix/services/main/ajax.php?mode=class&c=custom:api.v1.survey&action=hide',
                    {
                        'id': id
                    },
                    {
                        headers: headers
                    }
                );
            },
            send: function () {

                if(this.setRating < 10 && this.comment.length <= 5) {
                    alert("При оценки меньше 10 комментарий обязательный.");
                }else if(this.setRating > 0){
                    this.isModalVisible = false;
                    axios.post(
                        '/bitrix/services/main/ajax.php?mode=class&c=custom:api.v1.survey&action=answer',
                        {
                            'rate': this.setRating,
                            'comment': this.comment,
                        },
                        {
                            headers: {
                                'content-type': 'application/json; charset=utf8',
                                'X-Requested-With': 'XMLHttpRequest',
                                'X-Bitrix-Csrf-Token':BX.message('bitrix_sessid'),
                            }
                        }
                    );

                }else{
                    alert("Проставте оценку");
                }
            }
        },
        computed: {

        }
    }
</script>
